import { BREAKPOINTS, DeviceType } from '../enum/EnumRepository';

/**
 * 현재 윈도우 크기로 디바이스 타입 감지
 * @returns 디바이스 타입
 */
export const getCurrentScreenDeviceType = (): DeviceType => {
  const width = window.innerWidth;

  if (width <= BREAKPOINTS.MOBILE) return DeviceType.MOBILE;
  if (width <= BREAKPOINTS.TABLET) return DeviceType.TABLET;
  if (width <= BREAKPOINTS.LAPTOP) return DeviceType.LAPTOP;
  if (width <= BREAKPOINTS.DESKTOP) return DeviceType.DESKTOP;

  return DeviceType.DESKTOP;
};

/**
 * 이미지 크기 기반 디바이스 타입 감지 함수
 * @param width 이미지 너비
 * @param includeOrigin origin 타입 포함 여부 (기본값: false)
 * @returns 디바이스 타입
 */
export const getImageDeviceType = (width: number, includeOrigin: boolean = false): DeviceType | 'origin' => {
  if (width <= BREAKPOINTS.MOBILE) return DeviceType.MOBILE;
  if (width <= BREAKPOINTS.TABLET) return DeviceType.TABLET;
  if (width <= BREAKPOINTS.LAPTOP) return DeviceType.LAPTOP;
  if (width <= BREAKPOINTS.DESKTOP) return DeviceType.DESKTOP;

  return includeOrigin ? 'origin' : DeviceType.DESKTOP;
};